export const METHOD_GET = 'GET';
export const METHOD_POST = 'POST';
export const METHOD_PUT = 'PUT';
export const METHOD_DELETE = 'DELETE';
export const METHOD_PATCH = 'PATCH';

export const PATH_PREFIX = process.env.PATH_PREFIX;
export const PUBLIC_PATH = process.env.PUBLIC_PATH;

export const THAI_TIMEZONE_OFFSET = 7;

//events
export const WIN_CLICK = 'click';
export const WIN_RESIZE = 'resize';
export const WIN_SCROLL = 'scroll';
export const SCROLL_TO_TOP = 'scroll:top';
export const COOKIE_ID = 'userCId';
export const SHOW_LOADER = 'show_preloader';
export const SHOW_MESSAGE_TO_UI = 'show_message_to_ui';
export const LANG_SWITCHED = 'lang:switched';
export const SEARCH = 'search:g';
export const CLR_SEARCH = 'search:clr'; 
export const MENU_CLICKED = 'm:clicked';
export const CONFIRM_MENU_CLICK = 'cm:clicked';
export const TOGGLE_LEFTMENU = 'toggleleftmenu';
export const PATH_CHANGED = 'path:changed';
export const H1_CHANGED = 'h1:changed';
export const SHOW_LOGIN = 'login:show';
export const USER_SIGNIN = 'signin';
export const USER_SIGN_OUT = 'signout';
export const USER_PROFILE = 'userprofile';
export const RFRESH_TOKEN = 'usertoken:refresh';
export const EXPORT_TO_EDIT = "export_to_edit";
export const EXPORT_TO_APPROVE = "export_to_approve";
export const IMPORT_TO_REVIEW = "import_to_review";
export const CANCEL = "cancel";
export const EXPORT_TO_VIEW = "export_to_view";
export const IMPORT = "import";
export const SUBMIT_APPROVAL = "submit_for_approval";
export const SUBMIT_APPROVAL_ALL = "submit_for_approval_all";
export const SUBMIT_PUBLISHED = "submit_for_published";
export const SUBMIT_PUBLISHED_ALL = "submit_for_published_all";
export const APPROVE_INLINE = "approve_inline"; 
export const APPROVE_ALL = "approve_all"; 
export const RE_SUBMIT = "resubmit";
export const CHAT_ACTIVATED = "chatActivated"
//const LAUNCH_ACTION = "launch";
export const WITHDRAW = "withdraw";
export const ADD = 'add';
export const CACHE = 'addToCache';
export const EDIT = 'edit';
export const DELETE = "delete";
export const REJECT = 'reject';
export const ACTIONS = { ADD, EDIT, DELETE, WITHDRAW, SUBMIT_APPROVAL, SUBMIT_APPROVAL_ALL, EXPORT_TO_EDIT, EXPORT_TO_APPROVE, IMPORT, EXPORT_TO_VIEW, APPROVE_INLINE, APPROVE_ALL, RE_SUBMIT, REJECT, IMPORT_TO_REVIEW, CANCEL, SUBMIT_PUBLISHED, SUBMIT_PUBLISHED_ALL };
export const HOME_TITLE = 'Home';
export const LANG = 'lang';
export const CATEGORY = 'category';
export const PARAMS = 'params';
export const BEARER_KEY = 'Bearer ';
export const FLIP_LOADER = 'load:flip';
export const F_KEY = 'fq';
export const S_KEY = 'st';
export const C_KEY = 'ct';
export const O_KEY = 'so';
export const P_KEY = 'pg';
export const S_USER = 'su';
export const LIMIT = 'limit';
export const P_ITEMS_LIMIT = 25;
export const RES_SCREEN_MAX_WIDTH = 990;
export const TIMER_INTERVAL = 10000;
export const LEFT_MENU_COLLAPSE_TIMEOUT = 400;//seconds
export const UPDATE_ADDRESS = 'updateAddress';

export const USER_TKEY = 'datfu';

export const EXPIRES_AT = 'expt';
export const AUTH_KEY = 'Authorization';

//routes
export const DASHBOARD = 'dashboard';
export const LANDING = 'landing';
export const PRODUCTS = 'products';
export const PRODUCT = 'product';
export const COMPARE = 'compare';
export const CHECKOUT = 'checkout';
export const DEFAULT_LANDING_PAGE = 'products';

///
export const READY = "ready";
export const PROCESSING = "processing";
export const WAIT = "wait";
export const FAILURE = "FAILURE";

export const SUCCESS = 'success';
export const ERROR = 'error';
export const WARNING = 'warning';
export const DANGER = 'danger';
export const STATUS = { READY, WAIT, PROCESSING, SUCCESS, FAILURE };
//menu

//manage producs 
export const ALL = 'all';
export const DRAFT = 'draft';
export const PENDING_SUBMISSION = 'readytosubmit';
export const SUBMITTED_APPROVAL = 'pendingapproval';
export const PUBLISHED = 'published';
export const REJECTED = 'rejected';
export const CANCELLED = 'cancelled';
export const WITHDRAWN = 'withdrawn';
export const PENDING_SUBMISSION_DB = 'pendingSubmission';
export const DRAFT_DB = 'draft';
export const SUBMITTED_APPROVAL_DB = 'pendingApproval';
export const LAUNCHED_DB = 'live';
export const WITHDRAWN_DB = 'withdrawn';
 
export const ADD_PRODUCT = 'addproduct';
export const ADD_EDIT_PRODUCT = 'addeditproduct';
export const BULK_UPLOAD = 'bulkupload';
export const MEDIA_LIBRARY = 'medialibrary';
export const DOWNLOAD_TEMPLATE = 'download_template';
export const NEW_COLLECTION = 'new';
export const COLLECTION_EDIT = 'ce';
export const VARIANT_EDIT = 've';
export const ADD_PRODUCT_GROUP = 'addproductgroup'


export const PRODUCT_APPLN = 'productapplication';
export const PRODUCT_GROUP = 'productgroup';
export const ADD_PRODUCT_APPLN = 'addproductappln';
export const ADD_EDIT_PRODUCT_APPLN = 'addeditproductappln';
export const ADD_EDIT_PRODUCT_GROUP = 'addeditproductgroup';

export const ID_TO_ROUTE_MAP = new Map(
    [
        ['pg', PRODUCT_GROUP],
        ['pa', PRODUCT_APPLN],
        ['product', PRODUCTS]
    ]);

export const MP_SELECT_CHANGED = 'mange_products_select:changed';
export const IMAGE_DATA_CHANGED = 'imagedata:changed';
export const MEDIA_DATA_CHANGED = 'mediadata:changed';

// brands
export const BRANDS_LISTING = 'brands_listing';
export const BRANDS_ADD_EDIT = 'brands_add_edit';
export const BRANDS_SHORT_LIST_TRIM_LENGTH = 114;
export const BRANDS_IMG_SIZE_MAX = 1.5e+6;

// sellers
export const SELLERS_LISTING = 'sellers_listing';
export const SELLERS_ADD_EDIT = 'sellers_add_edit';
export const SELLERS_SHORT_LIST_TRIM_LENGTH = 114;
export const SELLERS_IMG_SIZE_MAX = 1.5e+6;

// warehouses
export const WAREHOUSES_LISTING = 'warehouses_listing';
export const WAREHOUSES_ADD_EDIT = 'warehouses_add_edit';

//changed warehouse new
export const ADD_EDIT_WAREHOUSE = 'warehouseeditadd';
export const WAREHOUSES_LIST = 'warehouse';

// pricing
export const PRICING = 'pricing';
export const PRICING_ALL_PRODUCTS = 'all_products';
export const PRODUCTS_ON_PRICE_PROMOTION = 'products_on_price_promotion';

// pricing promotions
export const PRICING_PROMOTIONS_TABS_ONGOING = 'ongoing';
export const PRICING_PROMOTIONS_TABS_UPCOMING = 'upcoming';
export const PRICING_PROMOTIONS_TABS_COMPLETED = 'completed';
export const PRICING_PROMOTIONS_TABS_ADD_PRICE_PROMOTION = 'add_price_promotion';
export const PRICING_PROMOTIONS_TABS_ADD_PRICE_PROMOTION_GROUP = 'add_price_promotion_group';

// promotion groups
export const PROMOTION_GROUPS_TABS_ONGOING = 'ongoing';
export const PROMOTION_GROUPS_TABS_UPCOMING = 'upcoming';
export const PROMOTION_GROUPS_TABS_COMPLETED = 'completed';
export const PROMOTION_GROUPS_TABS_ADD_PROMOTION_GROUP = 'add_promotion_group';

// promotion groups
export const COUPON_PROMOTIONS_TABS_ONGOING = 'ongoing';
export const COUPON_PROMOTIONS_TABS_UPCOMING = 'upcoming';
export const COUPON_PROMOTIONS_TABS_COMPLETED = 'completed';
export const COUPON_PROMOTIONS_TABS_ADD_COUPON_PROMOTIONS = 'add_coupon_promotions';
export const REFRESH_PROMOTION_SKUS = 'REFRESH_PROMOTION_SKUS';

// promotions
export const PROMOTION_PRODUCT_ASSOCIATION_ALL_SKUS = 'ALL_SKUS';
export const PROMOTION_PRODUCT_ASSOCIATION_SKU_LEVEL = 'SKU_LEVEL';
export const PROMOTION_PRODUCT_ASSOCIATION_CATEGORY_LEVEL = 'CATEGORY_LEVEL';

// media library
export const MEDIA_LIB_TABS_IMAGES = 'images';
export const MEDIA_LIB_TABS_VIDEOS = 'videos';
export const MEDIA_LIB_IMG_ACCEPT_EXTENSIONS = '.gif,.jpg,.jpeg,.png,.bmp,.tiff,.tif,.psd';
export const MEDIA_LIB_VID_ACCEPT_EXTENSIONS = '.mp4,.ogv';
// export const MEDIA_LIB_VID_ACCEPT_EXTENSIONS = '.avi,.flv,.wmv,.mp4,.mov, .mpg,.mpeg,.3gp,.f4v,.m4v,.m2t,.mts,.rmvb,.vob,.mkv';
export const MEDIA_LIB_UPLOAD_FILES_LIMIT = {
    [MEDIA_LIB_TABS_IMAGES]: 50,
    [MEDIA_LIB_TABS_VIDEOS]: 1,
};
export const MEDIA_LIB_GRID_COLUMNS = 4;

// analytics
export const ANALYTICS_TABS_CURRENT_LAST_DAYS = 'lastDays';
export const ANALYTICS_TABS_CURRENT_WEEK = 'currentWeek';
export const ANALYTICS_TABS_CURRENT_MONTH = 'currentMonth';
export const ANALYTICS_TABS_LAST_6MONTHS = 'last6Months';
export const ANALYTICS_TABS_LAST_3MONTHS = 'last3Months';
export const ANALYTICS_TABS_CURRENT_YEAR = 'currentYear';
export const ANALYTICS_TABS_CUSTOM_DATE_RANGE = 'customDateRange';
export const ANALYTICS_TAB_MAIN_TRIGGER = 'analyticsTabMainTrigger';
export const ANALYTICS_TAB_DRILL_DOWN_TRIGGER = 'analyticsTabDrillDownTrigger';

// analytics drilldown
export const ANALYTICS_DRILLDOWN_METRICS_IMPRESSIONS = 'impressions';
export const ANALYTICS_DRILLDOWN_METRICS_ADD_TO_CART_COUNT = 'addToCartCount';
export const ANALYTICS_DRILLDOWN_METRICS_ORDER_COUNT = 'orderCount';
export const ANALYTICS_DRILLDOWN_METRICS_PRODUCT_VIEWS = 'productViews';


// orders page tabs
export const PENDING_ACCEPTANCE = 'PENDING';
export const ACCEPTED_ORDERS = 'ACCEPTED';
export const ON_HOLD = 'ON_HOLD';
export const DELIVERED = 'DELIVERED';
export const OWN_DELIVERY = 'OWN_FULLFILLED';
export const OTHER_CARRIER_PICKUP = 'OTHER_CARRIER';
export const PENDING_INVOICE = 'PENDING_INVOICE';
export const PENDING_TRACKING_INFO = 'PENDING_TRACKING';
export const IN_TRANSIT = 'IN_TRANSIT';
export const COMPLETED_ORDERS = 'COMPLETED';
export const CANCELLED_ORDERS = 'CANCELLED';
export const READY_TO_SHIP = 'READYTOSHIP';
export const PAYMENT_PROCESSING = 'PAYMENT_PROCESSING';

// orders page actions
export const VIEW_PO = "VIEW_PO";
export const ACCEPT_PICKUP = 'ACCEPT_PICKUP';
export const REJECT_ORDER = 'REJECT_ORDER';
export const READY_TO_SHIP_BUTTON = 'READY_TO_SHIP_BUTTON';
export const READY_TO_PICKUP_BUTTON = 'READY_TO_PICKUP_BUTTON';
export const REJECT_OUT_STOCK = 'REJECT_OUT_STOCK';
export const REJECT_CANCEL_ORDER = 'REJECT_CANCEL_ORDER';
export const UPLOAD_INVOICE = "UPLOAD_INVOICE";
export const TRACK_INFO_PROVIDED = "TRACK_INFO_PROVIDED";
export const GENERATE_SHIPPING_LABELS = "GENERATE_SHIPPING_LABELS";
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE';
export const ORDER_ACTIONS = { VIEW_PO, ACCEPT_PICKUP, READY_TO_SHIP_BUTTON, REJECT_ORDER, REJECT_OUT_STOCK, REJECT_CANCEL_ORDER, UPLOAD_INVOICE, TRACK_INFO_PROVIDED, GENERATE_SHIPPING_LABELS, DOWNLOAD_INVOICE, READY_TO_PICKUP_BUTTON };
export const ORDERS_API_DATE_FORMAT = "DD-MM-YYYY";
export const ORDERS_PAGE_TAB_CHANGED = "ORDERS_PAGE_TAB_CHANGED";
export const REFRESH_ORDERS_COUNT = "REFRESH_ORDERS_COUNT";
export const CUSTOM_MADE = "CUSTOM_MADE";
// inventory
export const ALL_INVENTORY = 'all';
export const NO_STOCK_INVENTORY = 'OUT_OF_STOCK';
export const LOW_STOCK_INVENTORY = 'LOW_STOCK';
export const IN_STOCK_INVENTORY = 'IN_STOCK';
export const NO_STOCK_INVENTORY_COUNT = 'OUT_OF_STOCKcnt';
export const LOW_STOCK_INVENTORY_COUNT = 'LOW_STOCKcnt';
export const IN_STOCK_INVENTORY_COUNT = 'IN_STOCKcnt';

//installation
export const INSTALLATION_DOCUMENTS_ACCEPT_EXTENSIOINS = ".tar,.rar,.7z,.gif,.jpg,.jpeg,.png,.pdf,.zip";


export const NOTIFICATIONS_COUNT = 'notification_count'

export const ERRORS = {
    INVALID_CREDENTIALS: 'buyer.constants.invalid_credentials',
    INVALID_PASSWORD: 'buyer.constants.invalid_password',
    INVALID_TOKEN: 'seller.constants.invalid_token',
    USER_ALREADY_EXIST: 'seller.emaillinkhandler.user_already_exist',
    EMAIL_ALREADY_VERIFIED: 'seller.emaillinkhandler.email_already_verified',
    EMAIL_NOT_VERIFIED: 'seller.constants.email_not_verified',
    USER_VERIFICATION_FAILED: 'seller.user_verification_failed',
    USER_DISABLED: 'seller.user_disabled'
}

// data table configs
export const DATATABLE_LOCAL_PAGINATION_OPTIONS = {
    hideSizePerPage: true
};
export const LOAD_VARIANT = 'load_variant';
export const GROUP_SEARCH_SELECT_ITEMS_PROMOTIONS = [
    {
        label: 'seller.groupSearch.skuNumber',
        value: 'skuNumber'
    },
    {
        label: 'seller.groupSearch.webname',
        value: 'webname'
    },
    {
        label: 'seller.groupSearch.manuPartNumber',
        value: 'manuPartNumber'
    },
];

export const SESSION_EXPIRED = "sessionExpired";
export const PROFILE_UPDATED = "profileUpdated";

//ba
export const CART_ID = 'cartId';
export const ACTUAL_CART_ID = 'actualCartId';
export const PAGE = 'page';
export const PREV_PAGE = 'prevPage';
export const ACTION_AREA = 'area';
export const ATTR_TYPE = 'attrType';
export const ATTR_VALUE = 'attrValue';
export const BA_COOKIE_ID = 'cookieId';
export const BA_IP = 'ipaddress';
export const BA_SESSION_ID = 'sessionId';
export const BA_NOTE = 'note';
export const PAGE_NAV = 'Seller_Page Navigation';
export const PRODUCT_VIEWED = 'Impression';
export const PRODUCT_LISTED = 'Products Listed';
export const PAGE_ACTION = 'action';
export const DATE_TIME = 'datetime';
//export const COOKIE_ID = 'userCId';
export const PAGE_NO = 'pageNo';
export const ITEM_METRIX = 'item_metrix';
export const SHARED_By_USER = 'sharedByUser';
export const BROWSER_NAME = 'browser';
export const DEVICE_DETAILS = 'deviceDetails';
export const FLTR_ATTR = 'filter attribute';
export const BA_SEPARATOR = ',';
export const BA_ACTION_QC = 'Quantity Changed';
export const BA_ACTION_AC = 'Add to Cart';
export const BA_ACTION_MC = 'Merge Cart';
export const BA_ACTION_RFC = 'Removed from cart';
export const BA_ACTION_AW = 'Add to Wishlist';
export const BA_ACTION_RFW = 'Removed from Wishlist';
export const BA_ACTION_ACMP = 'Add to Compare';
export const BA_ACTION_RCMP = 'Removed from Compare';
export const BA_ACTION_NOTIFY = 'Email Notification';
export const BA_ACTION_CAP = 'Compare all products at once';
export const BA_ACTION_VW = 'View Details';
export const BA_ACTION_BA = 'Buy Again';
export const BA_ACTION_ANA = 'Add new address';
export const BA_ACTION_DI = 'Download invoice';
export const BA_ACTION_QV = 'Quick View';
export const BA_ACTION_FS = 'Free sample';
export const BA_ACTION_RWV = 'Reviews viewed';
export const BA_ACTION_WRR = 'Write Review';
export const FILTER_CHANGED = 'Filter Changed';
export const BA_ACTION_CR = 'Request for Cancel';
export const BA_ACTION_ICHECK = 'Installer Availability Check';

export const LOGIN_USER_DATA = "lud";
export const USER_NAME = "uerName";
export const USER_ID = "userId";
export const EMAIL = "email";
export const PAGE_TITLE = 'pageTitle';
export const PAGE_URL = 'pageUrl';
export const NO_OF_SEARCH_RESULTS = 'No of Search Results';
export const BA_ACTION_REVIEW_ORDER = "Review Order";
export const SHIPPING_METHOD = 'shippingMethod';
export const COVERAGE_CALCULATION = 'Coverage area calculation';
export const IMPERSONATED_USER_ID = "impersonateduserid"
export const IS_ADMIN = "isadmin"
export const ADD_EDIT_USERS = "addeditusers"
export const MANAGE_USERS = "manageusers"
export const STREAM_TYPE = "stream_type"
export const SESSION_ID = "sessionid"
export const COOKIE_SESSION_ID = 'PHPSESSID';
export const USER_SKEY = 'SESSION';
export const REFRESH_STATUS_TRACKING_INFO_SECTION = 'REFRESH_STATUS_TRACKING_INFO_SECTION';
export const ACCOUNT_TYPE = { INDIVIDUAL: "individual", COMPANY: "company" }

export const SCHEDULE_EXPORTS = 'scheduleexport';
export const ADD_EDIT_SCHEDULE_EXPORTS = 'addeditexports'; 


export const TABLE_ACTION_COL_OPTIONS={ EDIT: {type:"edit",label:"edit", icon:"fa-edit"},
                             DELETE: {type:"delete",label:"delete",icon:"fa-trash-alt"}  }

export const SIDE_BAR_WIDTH = 250;
